export default __webpack_public_path__ + "static/media/118.540cfbc6.jpg";